<script>
import MainLayout from '../layouts/mainLayout'
// import PopBox from '@/components/PopBox'
import dialog from '@/components/Dialog'
import {StringUtil} from '@/utils/StringUtil'
import {DateUtil} from '@/utils/date.js'
export default {
  components: {
    MainLayout,
    // PopBox
    // dialog 弹出框组件
    'v-dialog': dialog
  },
  created () {
    this.vehicle = JSON.parse(sessionStorage.getItem('vehicleDetail'))
    this.showBlock = !StringUtil.isEmpty(this.vehicle.blockStart)
  },
  data () {
    return {
      vehicle: {
        vehicleName: '',
        vehicleId: '',
        displayVehicleId: '',
        vehicleType: '',
        vehiclePlate: '',
        passengerNumber: '',
        joinDate: '',
        note: '',
        vehiclePhotoUrl: '',
        blockStart: '',
        blockEnd: '',
        blockNote: '',
        transportKind: '',
        transportName: '',
        transportId: ''
      },
      showDialogVehicle: false,
      showDialogBlock: false,
      dialogOptionVehicle: {
        showNo: true,
        text: 'この車両を削除してもよろしいですか？',
        cancelButtonText: 'キャンセル',
        confirmButtonText: '実行'
      },
      dialogOptionBlock: {
        showNo: true,
        text: 'この車両ブロックを取り消してもよろしいですか？',
        cancelButtonText: 'キャンセル',
        confirmButtonText: '実行'
      },
      showDeleteWrong: false,
      dialogDeleteWrong: {
        showNo: false,
        text: '車両は便に登録されています。削除できません。',
        confirmButtonText: 'OK'
      },
      showBlock: false,
    }
  },
  computed: {
    blockStart: function () {
      return DateUtil.yearWeekHourMinute(this.vehicle.blockStart)
    },
    blockEnd: function () {
      return DateUtil.yearWeekHourMinute(this.vehicle.blockEnd)
    }
  },
  methods: {
    goback () {
      this.$router.push({name: 'VehicleList'})
    },
    goEditor () {
      this.$router.push({name: 'VehicleEditor'})
    },
    goBlockEditor () {
      this.$router.push({name: 'VehicleBlockEditor'})
    },
    goSetting () {
      this.$router.push({name: 'VehicleSetting'})
    },
    deleteVehicle () {
      this.showDialogVehicle = true
      this.$refs.dialogVehicle
        .confirm()
        .then(() => {
          this.showDialogVehicle = false
          this.$axios.get('vehicle/deleteVehicle', {params: {vehicleId: this.vehicle.vehicleId}})
            .then((response) => {
              let status = response.data.status
              if (status === 0) {
                this.$router.push({name: 'VehicleList'})
              } else {
                this.showDeleteWrong = true
                this.$refs.dialogDeleteWrong.confirm()
                  .then(() => {
                    this.showDeleteWrong = false
                  })
                  .catch(() => {
                    this.showDeleteWrong = false
                  })
              }
            })
            .catch((error) => {
              console.log(error)
            })
        })
        .catch(() => {
          this.showDialogVehicle = false
        })
    },
    deleteVehicleBlock () {
      this.showDialogBlock = true
      this.$refs.dialogBlock
        .confirm()
        .then(() => {
          this.showDialogBlock = false
          this.vehicle.blockNote = null
          this.vehicle.blockStart = null
          this.vehicle.blockEnd = null
          console.log('deleteVehicleBlock')
          this.$axios.get('vehicle/deleteVehicleBlock', {params: {vehicleId: this.vehicle.vehicleId}})
            .then((response) => {
              console.log(response.data)
              sessionStorage.setItem('vehicleDetail', JSON.stringify(this.vehicle))
              this.showBlock = false
            })
            .catch((error) => {
              console.log(error)
            })
        })
        .catch(() => {
          this.showDialogBlock = false
        })
    },
    changeyyyyMMdd (dateStr) {
      return DateUtil.yearMonthDay(dateStr)
    },
  },
  prop: {
    
  }
}
</script>
<template>
  <MainLayout>
    <div class="vehicle-detail">
      <div class="row clearfix header">
          <div class="col-md-2 column headerleft F1-R-19">
            <input type="button" value="車両リストに戻る"  @click="goback"/>
          </div>
          <div class="col-md-8 column headermiddle F3-M-27">
            車両詳細
          </div>
      </div>
      <div class="body slider">
        <div class="row clearfix">
          <div class="col-md-3 column">
              <div v-if="!vehicle.vehiclePhotoUrl" class="vehicle_png bgc10 F2-M-18">No Image</div>
              <div v-else class="vehicle_png bgc10 F2-M-18">
                <img :src="vehicle.vehiclePhotoUrl" style="height: 100%;width: 100%;"/>
              </div>
          </div>
          <table class="table table-bordered window-table">
            <tbody>
            <tr>
              <td width='15%' class="td-key bgc8 F3-R-15">
                運行区分
              </td>
              <td class="td-value F3-M-18">
                <span v-show="vehicle.transportKind==0">区域内</span>
                <span v-show="vehicle.transportKind==1">区域外</span>
              </td>
            </tr>
            <tr v-if="vehicle.transportKind == 1">
              <td width='15%' class="td-key bgc8 F3-R-15">
                交通事業者
              </td>
              <td class="td-value F3-M-18">
                {{vehicle.transportName}}
              </td>
            </tr>
            <tr>
              <td width='15%' class="td-key bgc8 F3-R-15">
                車両名
              </td>
              <td class="td-value F3-M-18">
                {{vehicle.vehicleName}}
              </td>
            </tr>
            <tr>
              <td class="td-key bgc8 F3-R-15">
                車両ID
              </td>
              <td class="td-value F3-M-18">
                {{vehicle.displayVehicleId}}
              </td>
            </tr>
            <tr>
              <td class="td-key bgc8 F3-R-15">
                車種
              </td>
              <td class="td-value F3-M-18">
                {{vehicle.vehicleType}}
              </td>
            </tr>
            <tr>
              <td class="td-key bgc8 F3-R-15">
                車両ナンバー
              </td>
              <td  class="td-value F3-M-18">
                {{vehicle.vehiclePlate}}
              </td>
            </tr>
            <tr>
              <td class="td-key bgc8 F3-R-15">
                乗車定員
              </td>
              <td class="td-value F3-M-18">
                {{vehicle.passengerNumber}}人
              </td>
            </tr>
            <tr>
              <td class="td-key bgc8 F3-R-15">
                登録日
              </td>
              <td class="td-value F3-M-18">
                {{changeyyyyMMdd(vehicle.joinDate)}}
              </td>
            </tr>
            <tr >
              <td class="td-key bgc8 F3-R-15" :style="{textAlign:'center',lineHeight:vehicle.blockStart!=null?'75px':'110px'}">
                備考
              </td>
              <td class="td-value F3-M-18 tooLong">
              {{vehicle.note}}
              </td>
            </tr>
              </tbody>
          </table>
        </div>
        <div class="row clearfix" :style="{height:!showBlock?'218px':'253px'}">
            <div v-if="showBlock">
              <div class="col-md-3 column">
              </div>
              <table class="table table-bordered window-table">
                <tbody>
                <tr>
                  <td   colspan="2" class="td-key bgc3 F2-M-19" style="color:white">
                    車両ブロック
                  </td>
                </tr>
                <tr>
                  <td width='15%' class="td-key  bgc8 F3-R-15">
                    開始日
                  </td>
                  <td class="td-value F3-M-18">
                    {{blockStart.date}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{blockStart.time}}
                  </td>
                </tr>
                <tr>
                  <td class="td-key  bgc8 F3-R-15">
                    終了日
                  </td>
                  <td class="td-value F3-M-18">
                    {{blockEnd.date}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{blockEnd.time}}
                  </td>
                </tr>
                <tr >
                  <td class="td-key note-title  bgc8 F3-R-15">
                    備考
                  </td>
                  <td class="td-value F3-M-18 tooLong">
                  {{vehicle.blockNote}}
                  </td>
                </tr>
                  </tbody>
              </table>
            </div>
        </div>
      </div>

      <v-dialog v-show="showDialogVehicle" :dialog-option="dialogOptionVehicle" ref="dialogVehicle"></v-dialog>
      <v-dialog v-show="showDialogBlock" :dialog-option="dialogOptionBlock" ref="dialogBlock"></v-dialog>
      <v-dialog v-show="showDeleteWrong" :dialog-option="dialogDeleteWrong" ref="dialogDeleteWrong"></v-dialog>
      <!-- footer -->
      <div class="row clearfix footer">
        <div v-if="showBlock">
          <div class="col-md-3 column">
            <button class="vehicle-detail-btn" @click="goEditor">編集</button>
          </div>
          <div class="col-md-3 column">
            <button class="vehicle-detail-btn" @click="goBlockEditor">車両ブロック編集</button>
          </div>
          <div class="col-md-3 column">
            <button class="vehicle-detail-btn"  @click="deleteVehicleBlock">車両ブロック取り消す</button>
          </div>
          <div class="col-md-3 column">
            <button class="vehicle-detail-btn"  @click="deleteVehicle">車両を削除</button>
          </div>
        </div>

        <div v-if="!showBlock">
          <div class="col-md-4 column">
            <button class="vehicle-detail-btn"  @click="goEditor">編集</button>
          </div>
          <div class="col-md-4 column">
            <button class="vehicle-detail-btn" @click="goSetting">車両ブロック設定</button>
          </div>
          <div class="col-md-4 column">
            <button class="vehicle-detail-btn"  @click="deleteVehicle">車両を削除</button>
          </div>
        </div>
      </div>
    </div>
  </MainLayout>
</template>
<style lang="scss" scoped>
.vehicle-detail{
  display: flex;
  flex-direction: column;
  flex: 1 1 0;
  height: 50px;
}
.header{
    margin-bottom: 20px;
    position: relative;
    flex: 0 0 60px;
  }
.headerleft {
  margin-top: 20px;
  margin-left: 1.9%;
  width: 250px;
  z-index: 2;
  background: url(../../assets/button/back_button.png) no-repeat 10px center;
  // border: solid 2px #ccc;
  // border-radius: 20px;
}
.headerleft  input {
  float: left;
  border: none;
  background: none;
  height: 40px;
  line-height: 40px;
  width: 100%;
  text-align: left;
  text-indent: 30px;
}
.headermiddle {
  margin-top: 20px;
  height: 50px;
  line-height: 50px;
  position: absolute;
  width: 100%;
  font-size: 24px;
}
.body{
  flex: 1;
}
.tablediv {
  height: 600px;
  width: 100%;
  overflow-y: scroll;
  overflow-x: hidden;
  margin-left: 10px;
  margin-top: 10px;
}
.note-title{
  width:10%;
  text-align: center;
  line-height:75px;
}
.window-table{
  font-size: 16px;
  border: 1px solid #959595;
  width:72%;
 }
.vehicle-detail-btn{
  width: 90%;
  height: 55px;
  border-radius: 10px;
  font-size: 20px;
  color: #fff;
  background:linear-gradient(rgb(112, 182, 202) 50%, rgb(72,163,190) 50%);
  border: 0;
}
.table-bordered>tbody>tr>td{
  border: 1px solid #959595;
}
.td-title{
  background-color: #797979;
  color: #fff;
  font-size: 22px;
}
.td-key{
 background-color: #DDDDDD;
}
.table>tbody>tr>td{
  padding:9px;
}
.table>tbody>tr>.td-value{
  padding-left: 20px;
}
.td-value{
  text-align: left;
  border: 1px solid #959595;
}
.td-remark{
  height: 100px;
}
.vehicle_png{
  margin-left: 3%;
  height:225px;
  background: rgb(120, 120, 120);
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
}
.footer{
  margin-top: 20px;
  margin-bottom: 25px;
}
.tooLong{
    word-wrap: break-word;
    word-break: break-all;
}
@media screen and (max-device-width: 1480px) {
  .window-table{
    font-size: 12px;
  }
  .body{
    height: 50%;
  }
  .vehicle-detail-btn{
    font-size: 16px;
  }
}
</style>



// WEBPACK FOOTER //
// src/router/views/VehicleDetail.vue